document.addEventListener("DOMContentLoaded", () => {
  const reviewForm = document.getElementById("new-review");

  if (reviewForm) {
    document
      .querySelectorAll(
        "#review_recommendation, #review_rating, #review_online_class_id",
      )
      .forEach((element) => {
        element.addEventListener("input", () =>
          reviewForm.dispatchEvent(
            new Event("submit", {
              bubbles: true,
              cancelable: true,
            }),
          ),
        );
      });

    reviewForm.dispatchEvent(
      new Event("submit", {
        bubbles: true,
        cancelable: true,
      }),
    );
  }

  // Set value to input on button click
  const ratingHidden = document.querySelector(".rating-hidden");
  const reviewRating = document.querySelector(".review_rating");
  if (
    ratingHidden instanceof HTMLInputElement &&
    reviewRating instanceof HTMLInputElement
  ) {
    document.querySelectorAll(".rating-list > button").forEach((btn) => {
      if (!(btn instanceof HTMLButtonElement)) return;

      btn.addEventListener("click", () => {
        ratingHidden.value = btn.dataset.value || "";
        reviewRating.value = btn.dataset.text || "";
        reviewForm?.dispatchEvent(
          new Event("submit", {
            bubbles: true,
            cancelable: true,
          }),
        );
      });
    });
  }
});
